import React from 'react';
import { doLogin } from '../../utils/auth';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';

class LoginForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            rememberMe: true,
        };
    }

    handleChange = name => e => {
        if (name === 'rememberMe') {
            this.setState({
                rememberMe: e.target.checked
            });
        } else {
            this.setState({
                [name]: e.target.value
            });
        }
    };

    handleSubmit = e => {
        const { username, password, rememberMe } = this.state;
        const trimmedUsername = username && username.trim();
        const trimmedPassword = password && password.trim();
        e.preventDefault();

        this.requestRecaptcha()
            .then(recaptcha => {
                const data = `username=${trimmedUsername}&password=${encodeURIComponent(trimmedPassword)}&rememberMe=${rememberMe}&recaptcha=${recaptcha}`;

                doLogin(data)
                    .then((user) => {
                        this.props.onSubmitted(user);
                    })
                    .catch(err => {
                        this.props.onError(err)
                    });
            })
    };

    requestRecaptcha = () => {
        const { googleReCaptchaProps: { executeRecaptcha } } = this.props;
        return executeRecaptcha('login');
    }

    render() {
        const { username, password, rememberMe } = this.state;
        return (
            <div className="nakednews-form">
                <div className="nakednews-form-error" />
                <form
                    id="modal_new_customer"
                    noValidate="novalidate"
                    className="formtastic form-horizontal customer login-form"
                    acceptCharset="UTF-8"
                    data-remote="true"
                    onSubmit={this.handleSubmit}
                >
                    <input name="utf8" type="hidden" defaultValue="✓" />
                    <div
                        className="hidden input optional form-group"
                        id="modal_customer__tgt_url_input"
                    >
                        <label
                            htmlFor="modal_customer__tgt_url"
                            className="col-lg-3 control-label"
                        >
                            Tgt url
                        </label>
                        <div className="col-lg-12">
                            <input
                                className="form-control"
                                defaultValue="/"
                                id="modal_customer__tgt_url"
                                type="hidden"
                                name="customer[_tgt_url]"
                            />
                        </div>
                    </div>
                    <div
                        className="string input optional stringish form-group"
                        id="modal_customer_username_input"
                    >
                        <div className="col-lg-12">
                            <input
                                className="form-input username"
                                placeholder="Username / Email"
                                id="modal_customer_username"
                                type="text"
                                name="customer[username]"
                                value={username}
                                autoCapitalize="none"
                                onChange={this.handleChange('username')}
                            />
                        </div>
                    </div>
                    <div
                        className="password input optional stringish form-group"
                        id="modal_customer_password_input"
                    >
                        <div className="col-lg-12">
                            <input
                                className="form-input password"
                                placeholder="Password"
                                id="modal_customer_password"
                                type="password"
                                name="customer[password]"
                                value={password}
                                onChange={this.handleChange('password')}
                            />
                        </div>
                    </div>
                    <div
                        className="boolean input optional form-group"
                        id="modal_customer_remember_me_input"
                    >
                        <input
                            type="hidden"
                            name="customer[remember_me]"
                            defaultValue={0}
                        />
                        <div className="col-lg-12">
                            <div className="checkbox">
                                <label
                                    htmlFor="modal_customer_remember_me"
                                    className=" form-switch"
                                >
                                    <input
                                        type="checkbox"
                                        name="customer[remember_me]"
                                        id="modal_customer_remember_me"
                                        checked={rememberMe}
                                        onChange={this.handleChange(
                                            'rememberMe'
                                        )}
                                    />
                                    <i></i>
                                    Remember Me
                                </label>
                            </div>
                            <div className="form-group">
                                <div className="col-lg-12">
                                    <button
                                        name="button"
                                        type="submit"
                                        className="btn btn-black action-button"
                                        id="modal_customer_submit_button"
                                    >
                                        Login
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default withGoogleReCaptcha(LoginForm);
